
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/catalogue",
      function () {
        return require("private-next-pages/catalogue/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/catalogue"])
      });
    }
  